/**
 * Site-wide Content
 *
 * Shared content used across multiple pages: business info,
 * header/navigation, footer, social links, etc.
 */

const siteContent = {
  /* ───────────────────── Brand ───────────────────── */
  brand: {
    name: 'Huqup - Cafe & Grill',
    shortName: 'Huq up',
    tagline: 'Cafe & Grill',
    logo: 'logo.png',
    sidebarLogo: 'sidebar-logo.png',
  },

  /* ─────────────────── Business Info ─────────────── */
  businessInfo: {
    address: '27052 E University Dr, Suite 100, Little Elm, TX',
    fullAddress: 'Huq up, 27052 E University Dr Suite 100, Little Elm, TX 75068',
    phone: '+1 (469) 724-1846',
    phoneLink: 'tel:+14697241846',
    email: 'huqupcafe@gmail.com',
    emailLink: 'mailto:huqupcafe@gmail.com',
    hours: 'Sun–Thu : 11 AM – 2 AM | Fri–Sat : 11 AM – 3 AM',
    hoursShort: 'Open : 11 AM – 2 AM / 3 AM',
    openTime: '11:00 AM',
    closeTimeSunThu: '02:00 AM',
    closeTimeFriSat: '03:00 AM',
  },

  /* ─────────────────── Social Links ─────────────── */
  socialLinks: [
    { name: 'Facebook', icon: 'fab fa-facebook-f', url: '#' },
    { name: 'Instagram', icon: 'fab fa-instagram', url: 'https://www.instagram.com/huq_up_/' },
    { name: 'Youtube', icon: 'fab fa-youtube', url: '#' },
    { name: 'Google Map', icon: 'fas fa-map-marker-alt', url: 'https://maps.app.goo.gl/C8yeSu9BBehVeJ6GA' },
  ],

  /* ─────────── Header / Navigation ──────────────── */
  navigation: {
    mainNav: [
      {
        label: 'Home',
        path: '/',
        dropdown: [
          { label: 'Home 1 Left Header', path: '/' },
          { label: 'Home 1 Center Header', path: '/hometwo' },
          { label: 'Home 3 Video Hero', path: '/homethree' },
        ],
      },
      {
        label: 'Menu',
        path: '/menu',
        megaMenu: true,
        items: [
          { label: 'Menu List 1', path: '/menu', image: 'menu-image-1.jpg' },
          { label: 'Menu List 2', path: '/menutwo', image: 'menu-image-2.jpg' },
          { label: 'Menu List 3', path: '/menuthree', image: 'menu-image-3.jpg' },
          { label: 'Menu List 4', path: '/menufour', image: 'menu-image-4.jpg' },
        ],
      },
      { label: 'About Us', path: '/about' },
      { label: 'Our chefs', path: '/ourchefs' },
      { label: 'Contact', path: '/contact' },
    ],
    sidebarNav: [
      { label: 'Home', path: '/' },
      { label: 'View Menu', path: '/menu' },
    //   { label: 'About Us', path: '/about' },
      { label: 'Contact', path: '/contact' },
    ],
    ctaButton: { label: 'find a table', path: '/reservation' },
  },

  /* ─────────────────── Footer ────────────────────── */
  footer: {
    backgroundImage: 'image-4.jpg',
    copyright: '© 2026 Huq up. All Rights Reserved | Designed with ❤ by Bogin Tech',
    copyrightLink: 'https://bogin.tech',
    newsletter: {
      title: 'Get News & Offers',
      subtitle: 'Subscribe us & Get 25% Off.',
    },
    quickLinks: [
      { label: 'Home', path: '/' },
      { label: 'View Menu', path: '/menu' },
    //   { label: 'About us', path: '/about' },
      { label: 'Contact', path: '/contact' },
    ],
  },
};

export default siteContent;
